"use strict";
require("./map");
if (typeof document !== "undefined") {
    require("./lib/renderable/map/style.scss");
}
